import { render } from "./ProductTypeView.vue?vue&type=template&id=0ba57d8f&scoped=true"
import script from "./ProductTypeView.vue?vue&type=script&lang=js"
export * from "./ProductTypeView.vue?vue&type=script&lang=js"

import "./ProductTypeView.vue?vue&type=style&index=0&id=0ba57d8f&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba57d8f"]])

export default __exports__